"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
exports.displayName = 'Input';
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.render = function () {
        var _a = this.props, className = _a.className, hasError = _a.hasError, inputRef = _a.inputRef, tag = _a.tag, errorClassname = _a.errorClassname, errorComponent = _a.errorComponent, rest = __rest(_a, ["className", "hasError", "inputRef", "tag", "errorClassname", "errorComponent"]);
        var conditionalClasses = {
            'p-bc-f-blue50': !hasError,
            'is-disabled': this.props.disabled
        };
        conditionalClasses[errorClassname || 'p-b-error p-bc-error50'] = hasError;
        var style = classnames('p-textbox-input', 'p-bc-grey40', 'p-bg-hv-white', conditionalClasses, className);
        var attr = __assign({ 'data-tag': tag, className: style, ref: inputRef }, rest);
        return React.createElement("input", __assign({}, attr));
    };
    Input.displayName = exports.displayName;
    return Input;
}(React.PureComponent));
exports.Input = Input;
exports.default = Input;
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/components/Input.js
// module id = 328
// module chunks = 0